<template>
  <div>
    <div class="slider">
      <img id="img-1" src="/images/hero_image@3x.png" alt="Image 1" />
    </div>
    <div class="navigation-button">
      <span class="dot active" @click="changeSlide(0)"></span>
      <span class="dot" @click="changeSlide(1)"></span>
      <span class="dot" @click="changeSlide(2)"></span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Slider',
  components: {},
  data() {
    return { timer: null, interval: 3000, timeoutId: null, currentImg: 0 };
  },
  computed: {},
  watch: {},
  methods: {
    changeSlide() {
      var imgs = document.querySelectorAll('.slider img');
      let dots = document.querySelectorAll('.dot');
      for (var i = 0; i < imgs.length; i++) {
        imgs[i].style.opacity = 0;
        dots[i].className = dots[i].className.replace(' active', '');
      }
      this.currentImg = (this.currentImg + 1) % imgs.length;
      imgs[this.currentImg].style.opacity = 1;
      dots[this.currentImg].className += ' active';
    },
    calculateDays(today, eventDate) {
      const difference = eventDate.getTime() - today.getTime();
      return Math.ceil(difference / (1000 * 3600 * 24)); // convert to days
    },
    startInterval() {
      this.intervalId = setInterval(() => {
        this.myFunction();
      }, 9000);
    },
    stopInterval() {
      clearInterval(this.intervalId);
    },
    myFunction() {
      this.changeSlide();
    },
  },
  created() {},
  mounted() {
    this.startInterval();
  },
  beforeDestroy() {
    this.stopInterval();
  },
};
</script>
<style lang="scss" scoped>
.slider {
  width: 100%;
  height: 408px;
  position: relative;
  overflow: hidden;
  @media screen and (max-width: 2400px) {
    height: 538px;
  }
  @media screen and (max-width: 2200px) {
    height: 528px;
  }
  @media screen and (max-width: 2000px) {
    height: 518px;
  }
  @media screen and (max-width: 1800px) {
    height: 508px;
  }
  @media screen and (max-width: 1600px) {
    height: 498px;
  }
  @media screen and (max-width: 1400px) {
    height: 488px;
  }
  @media screen and (max-width: 1200px) {
    height: 478px;
  }
  @media screen and (max-width: 1095px) {
    height: 468px;
  }
  @media screen and (max-width: 1024px) {
    margin-top: -20px;
  }
  @media screen and (max-width: 995px) {
    height: 458px;
  }
  @media screen and (max-width: 895px) {
    height: 448px;
  }
  @media screen and (max-width: 850px) {
    height: 438px;
  }
  @media screen and (max-width: 768px) {
    height: 428px;
  }
  @media screen and (max-width: 767px) {
    margin-top: 0px;
  }
  @media screen and (max-width: 668px) {
    height: 418px;
  }
  @media screen and (max-width: 568px) {
    height: 408px;
  }
  @media screen and (max-width: 468px) {
    height: 398px;
  }
  @media screen and (max-width: 420px) {
    height: 388px;
  }
  @media screen and (max-width: 400px) {
    height: 398px;
  }
  @media screen and (max-width: 390px) {
    height: 388px;
  }
  @media screen and (max-width: 380px) {
    height: 378px;
  }
  @media screen and (max-width: 370px) {
    height: 368px;
  }
  @media screen and (max-width: 360px) {
    height: 358px;
  }
  @media screen and (max-width: 350px) {
    height: 348px;
  }
  @media screen and (max-width: 340px) {
    height: 338px;
  }
  @media screen and (max-width: 330px) {
    height: 310px;
  }
  @media screen and (max-width: 320px) {
    height: 302px;
  }

  // // @media screen and (max-width: 1095px) {
  // //   height: 500px;
  // // }
  // // @media screen and (max-width: 1095px) {
  // //   height: 500px;
  // // }
  // @media screen and (max-width: 500px) {
  //   height: 302px;
  // }
}

.slider img {
  // width: 100%;
  // position: absolute;
  // top: 0;
  // left: 0;
  position: absolute; /* Posicionar la imagen dentro del contenedor */
  top: 0;
  left: 0;
  width: 100%; /* El elemento <img> ocupa el 100% del ancho del contenedor */
  height: 100%; /* El elemento <img> ocupa el 100% de la altura del contenedor */
  object-fit: cover;
  @media screen and (max-width: 768px) {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  /* transition: all 0.5s ease-in-out; */
}

.slider img:first-child {
  z-index: 1;
}

.slider img:nth-child(2) {
  z-index: 0;
}

.navigation-button {
  text-align: center;
  position: relative;
}

.dot {
  display: none;
  cursor: pointer;
  height: 15px;
  width: 15px;
  margin: 0 2px;
  background-color: #bbb;
  border-radius: 50%;
}

.active,
.dot:hover {
  background-color: #717171;
}
</style>
